import React from 'react';
import { Media } from 'reactstrap';
// import error from "../../images/404.svg";
//  import error from "../../images/404-Error-Page.jpg"
import NotFoundImage from "../../images/NotFound.jpg"
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
    const navigate = useNavigate();

    const handleChange = (e) =>{
    // window.history.go(-1);
    e.currentTarget.blur();
    navigate("/",  { replace: true }) 
    return false;
}

    return (
        <>
            <div>
                <div className="error-section">
                    <Media className="img-fluid" src={NotFoundImage} alt="image" />
                    <div className="error-content">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <h1>Uh oh!</h1>
                                    <p>Sorry, we could not find that page you were looking for. the page may have been moved permanently.</p>
                                    {/* <a href ={`${process.env.PUBLIC_URL}/`}> */}
                                    <button type="button" class="btn btn-primary" onClick={handleChange} aria-label="go to back pagge">Go to Back page</button>
                                    {/* </a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
